import { render, staticRenderFns } from "./ModelsTable.vue?vue&type=template&id=7d90b672&scoped=true&"
import script from "./ModelsTable.vue?vue&type=script&lang=js&"
export * from "./ModelsTable.vue?vue&type=script&lang=js&"
import style0 from "./ModelsTable.vue?vue&type=style&index=0&id=7d90b672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d90b672",
  null
  
)

export default component.exports